import { render } from "./Redacted.vue?vue&type=template&id=8bd3d196"
import script from "./Redacted.vue?vue&type=script&lang=js"
export * from "./Redacted.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__